/* ORAVIE - bundle product page interactions. No dependencies. */
(function () {
  'use strict';
  var each = function (l, f) { Array.prototype.forEach.call(l, f); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Gallery.
     One scroll-snap strip drives every breakpoint: a swipe on a phone, a
     thumbnail click on a desktop. The counter is read back from the real
     scroll position, so it can never disagree with what is on screen. */
  function gallery() {
    var g = document.querySelector('[data-evgal]');
    if (!g) return;
    var strip = g.querySelector('[data-evstrip]');
    if (!strip) return;
    var thumbs = g.querySelectorAll('[data-evthumb]');
    var idx = g.querySelector('[data-evidx]');
    var current = -1;
    var tick = 0;

    function mark(i) {
      if (i === current || i < 0) return;
      current = i;
      if (idx) idx.textContent = i + 1;
      each(thumbs, function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    function read() {
      var w = strip.clientWidth;
      if (!w) return;
      mark(Math.round(strip.scrollLeft / w));
    }
    strip.addEventListener('scroll', function () {
      if (tick) return;
      tick = window.requestAnimationFrame(function () { tick = 0; read(); });
    }, { passive: true });
    window.addEventListener('resize', read, { passive: true });

    each(thumbs, function (t, i) {
      t.addEventListener('click', function () {
        strip.scrollTo({ left: i * strip.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        mark(i);
      });
    });
    read();
  }

  /* Bundle tiers.
     Every figure on screen - headline price, struck reference, savings badge,
     per-box figure, the shipping line, the CTA and the sticky bar - is written
     by Liquid onto the radio input and simply copied out here. Nothing is
     recalculated in the browser, so the page cannot drift away from what the
     cart will charge. */
  function tiers() {
    var form = document.getElementById('pform');
    if (!form) return;
    var inputs = form.querySelectorAll('[data-evtier]');
    if (!inputs.length) return;
    var qty = form.querySelector('[name="quantity"]');
    var vid = form.querySelector('[name="id"]');

    function fill(sel, value) {
      each(document.querySelectorAll(sel), function (el) { el.textContent = value || ''; });
    }
    function show(sel, on) {
      each(document.querySelectorAll(sel), function (el) { el.hidden = !on; });
    }

    function apply(i) {
      var was = i.getAttribute('data-was') || '';
      var save = i.getAttribute('data-save') || '';
      if (qty) qty.value = i.getAttribute('data-qty') || '1';
      if (vid && i.getAttribute('data-vid')) vid.value = i.getAttribute('data-vid');
      fill('[data-evnow]', i.getAttribute('data-now'));
      fill('[data-evpay]', i.getAttribute('data-now'));
      fill('[data-eveach]', i.getAttribute('data-each'));
      fill('[data-evlabel]', i.getAttribute('data-label'));
      fill('[data-evship]', i.getAttribute('data-ship'));
      fill('[data-evwas]', was);
      fill('[data-evsave]', save);
      show('[data-evwas]', was !== '');
      show('[data-evsave-box]', save !== '');
    }

    each(inputs, function (input) {
      input.addEventListener('change', function () { if (input.checked) apply(input); });
      if (input.checked) apply(input);
    });
  }

  /* Marquee: clone the row once so the -50% translation loops seamlessly. */
  function marquee() {
    each(document.querySelectorAll('[data-evmq]'), function (track) {
      if (reduce) return;
      var row = track.firstElementChild;
      if (!row) return;
      track.appendChild(row.cloneNode(true));
    });
  }

  /* Before / after: a real range input drives the clip width, so it is
     keyboard accessible rather than a synthesised drag. */
  function beforeAfter() {
    each(document.querySelectorAll('[data-evba]'), function (box) {
      var range = box.querySelector('input[type="range"]');
      var clip = box.querySelector('[data-evba-clip]');
      if (!range || !clip) return;
      var set = function () { clip.style.width = range.value + '%'; };
      range.addEventListener('input', set);
      set();
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () { gallery(); tiers(); marquee(); beforeAfter(); });
})();
